<template>
	<div style="position: relative;">
		<div style="position: relative;font-size: 0;">
			<img src="../assets/zy/top.png" style="width: 100%;"/>
		</div>
		<div class="centerDiv" v-if="data">
			<div style="display: flex;align-items: center;justify-content: space-between;width: 90%;margin: 0 auto;padding-top: 5px;">
				<img @click="show_cyzn" src="../assets/zy/cyzn.png" style="width: 18.9%;margin-right: 3%;"/>
				<img @click="goPhb" src="../assets/zy/ztyxb.png" style="width: 0;flex: 1;"/>
				<img @click="show_jljz" src="../assets/zy/jljz.png" style="width: 18.9%;margin-left: 3%;"/>
			</div>
			
			<div style="display: flex;margin-left: 2%;margin-top: 10px;align-items: center;">
				<div style="width: 3%;background-color: #fff0bb;height: 50px;"></div>
				<div style="width: 1.2%;background-color: #fff0bb;height: 50px;margin-left: 1%;"></div>
				<div style="color: #ffdd83;margin-left: 3px;">
					<div style="font-size: 1.5rem;font-weight: bolder;">{{data.ypname}}</div>
					<div style="font-size: 1rem;font-weight: bolder;">{{data.begindate}}—{{data.enddate}}</div>
				</div>
			</div>
			<div style="position: relative;margin-top: 10px;">
				<div style="position: relative;font-size: 0;">
					<img src="../assets/zy/xk.png" style="width: 100%;"/>
				</div>
				<!-- <div v-if="playerOptions">
					<video-player :options="playerOptions"></video-player>
				</div> -->
				<div style="position: relative;font-size: 0;margin-top: -1px;">
					<a :href="data.hshslist.slowlivelink" target="_blank">
						<img :src="data.hshslist.slowliveimg" style="width: 100%;"/>
					</a>
					
				</div>
				<div style="position: relative;background-color: #ffe68d;display: flex;padding: 5px 2%;align-items: center;">
					<!-- <div style="background-color: #893609;border-radius: 5px;padding: 3px;font-size: 1.3rem;">
						
					</div> -->
					<img src="../assets/zy/hshs.png" style="width: 15%;margin-right: 10px;"/>
					<div style="width: 0;flex: 1;color: #893609;font-size: 1.5rem;font-weight: bolder;">
						{{data.hshslist.slowlivename}}
					</div>
				</div>
				<div style="position: relative;font-size: 0;margin-top: -1px;">
					<img src="../assets/zy/xk.png" style="width: 100%;"/>
				</div>
			</div>
			<div style="width: 90%;margin: 0 auto;margin-top: 15px;">
				<div v-for="(item,index) in flimlist" @click="changeTab(index,item.film_id)" :style="'margin-top: 12px;display: inline-block;width: 49%;font-size: 0;position: relative;box-sizing: border-box;'+(index%2==0?'margin-right: 2%;':'')">
					<img :src="item.film_pic" style="width: 100%;"/>
					<div v-if="fm_index==index" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;border: 3px solid #fff097;box-sizing: border-box;"></div>
				</div>
				
				<div style="background-color: #fff;border-radius: 5px;padding: 0 5%;margin-top: 15px;height: 500px;overflow-y: auto;">
					<van-list
					  v-model="loading"
					  :finished="finished"
					  finished-text="没有更多了"
					  @load="onLoad"
					>
					  <div v-for="(item,index) in ly_list" style="display: flex;padding: 20px 0;border-bottom: 1px solid #d3d3d3;align-items: flex-start;">
					  	<img :src="item.headimg" style="width: 50px;border-radius: 50%;margin-right: 10px;"/>
					  	<div style="width: 0;flex: 1;">
					  		<div style="display: flex;justify-content: space-between;align-items: flex-start;">
					  			<div style="width: 0;flex: 1;font-size: 1rem;">
					  				<div>{{item.nickname}}</div>
					  				<div style="color: #b4b4b4;font-size: 0.8rem;margin-top: 3px;">{{item.regdate}}</div>
					  			</div>
					  			<div style="width: 80px;margin-left: 20px;display: flex;align-items: center;color: #b4b4b4;font-size: 0.8rem;justify-content: flex-end;">
					  				<div @click="dianzan(item.lyid,index)" style="display: flex;align-items: center;">
										<img :src="item.zansign==0?wdzImg:ydzImg" style="width: 13px;margin-right: 3px;"/>
										<div>{{item.votenum}}</div>
									</div>
					  				<!-- <img src="../assets/zy/pl.png" style="width: 13px;margin-left: 15px;"/> -->
					  			</div>
					  		</div>
					  		<div style="font-size: 1.1rem;margin-top: 5px;">{{item.content}}</div>
					  	</div>
					  </div>
					</van-list>
					
					
				</div>
				<div style="background-color: #fff;padding: 0px;margin-top: 15px;">
					<van-field
					  v-model="message"
					  rows="3"
					  autosize
					  type="textarea"
					  placeholder="留下你的影评吧"
					/>
				</div>
				<div style="text-align: center;margin-top: 12px;padding-bottom: 10px;">
					<img @click="fabu" src="../assets/zy/fb.png" style="width: 50%;"/>
				</div>
			</div>
		</div>
		<div style="position: relative;font-size: 0;margin-top: -1px;">
			<a href="https://jiyun.hebyun.com.cn/topic/2025/12/10/f5409734e65c459f80b2ed243a21ef4c.html" target="_blank">
				<img src="../assets/zy/hshs1.png" style="width: 100%;"/>
			</a>
			
		</div>
		<div style="position: relative;font-size: 0;margin-top: -1px;">
			<img src="../assets/zy/bot1.png" style="width: 100%;"/>
		</div>
		<div style="position: relative;font-size: 0;margin-top: -1px;text-align: center;" class="bot2">
			<img src="../assets/zy/gyrl.jpg" style="width: 90%;"/>
		</div>
		<div style="position: relative;font-size: 0;margin-top: -1px;">
			<img src="../assets/zy/bot3.png" style="width: 100%;"/>
		</div>
		<div v-if="cyzn_flag" style="position: fixed;top: 0;left: 0;width: 100vw;height: 100vh;overflow-y: auto;background-color: rgba(0, 0, 0, 0.6);">
			<div style="text-align: center;padding: 30px 20px;">
				<img src="../assets/zy/cyzntc.png" style="width: 100%;" />
				<img @click="cyzn_flag=false" src="../assets/zy/gb.png" style="width: 13%;margin-top: 20px;" />
			</div>
		</div>
		<div v-if="jljz_flag" style="position: fixed;top: 0;left: 0;width: 100vw;height: 100vh;overflow-y: auto;background-color: rgba(0, 0, 0, 0.6);">
			<div style="text-align: center;padding: 30px 20px;">
				<img src="../assets/zy/jljztc.png" style="width: 100%;" />
				<img @click="jljz_flag=false" src="../assets/zy/gb.png" style="width: 13%;margin-top: 20px;" />
			</div>
		</div>
		
		<div v-if="jiazai_flag" style="position: fixed;top: 0;left: 0;height: 100%;width: 100%;background-color: rgba(0,0,0,0.5);z-index: 600;">
			<div style="position: absolute;top: 45%;;width: 100%;" align="center">
				<img src="../assets/loading.gif" style="width: 30px;" />
				<!-- <div style="color: #FFFFFF;font-size: 1rem;">正在生成海报</div> -->
			</div>
		</div>
	</div>
	

</template>

<script>
	import { videoPlayer } from 'vue-video-player'
	import 'video.js/dist/video-js.css'
	import 'vue-video-player/src/custom-theme.css'
	
	import Field from 'vant/lib/field';
	import 'vant/lib/field/style';
	import Vue from 'vue';
	Vue.use(Field);
	
	import Toast  from 'vant/lib/toast';
	import 'vant/lib/toast/style';
	
	Vue.use(Toast);
	
	import List  from 'vant/lib/list';
	import 'vant/lib/list/style';
	
	Vue.use(List);
	import {
		addContent
	} from "@/api/index";
	export default {
		name: 'index',
		components: {videoPlayer},
		data() {
			return {
				data:null,
				jiazai_flag:false,
				cyzn_flag: false,
				jljz_flag: false,
				message:'',
				fm_index:0,
				playerOptions: null,
				ly_list:[],
				flimlist:[],
				filmid:null,
				
				
				list: [],
				loading: false,
				finished: false,
				pagenow:1,
				
				wdzImg: require('../assets/zy/wdz.png'),
				ydzImg: require('../assets/zy/ydz.png')

			}
		},
		methods: {
			fabu(){
				if (!this.message) {
					return
				}
				var datajson = {
					"ypid":ypid,
					"filmid":this.filmid,
					"wxopenid":wxopenid,
					"headimg":headimg,
					"nickname":nickname,
					"content":this.message,
				};
				datajson = JSON.stringify(datajson);
				$.ajax({
					type: "get",
					url: "https://mediaapi.hebei.com.cn/api/2025filmreview/api/receive.php?message=" + datajson,
					datatype: "json",
					beforeSend: ()=> {
						this.jiazai_flag=true
					},
					complete: ()=> {
						this.jiazai_flag=false
					},
					//成功返回之后调用的函数
					success: (data)=> {
						console.log("data：",data)
						data = JSON.parse(data)
						if (data.code + '' == '1') {
							
							this.message=null
							
							Toast("提交成功")
						} else {
							Toast(data.data)
						}
					}
				})
			},
			changeTab(index,film_id){
				if (index==this.fm_index) {
					return
				}
				this.fm_index = index
				this.filmid = film_id
				this.ly_list=[]
				this.pagenow=1
				this.finished = false;
				// this.get_ly_list(film_id)
			},
			dianzan(lyid,index){
				var datajson = {
					"ypid":ypid,
					"filmid":this.filmid,
					"wxopenid":wxopenid,
					"lyid":lyid
				};
				datajson = JSON.stringify(datajson);
				$.ajax({
					type: "get",
					url: "https://mediaapi.hebei.com.cn/api/2025filmreview/api/zan.php?vote=" + datajson,
					datatype: "json",
					//成功返回之后调用的函数
					success: (data)=> {
						if (this.ly_list[index].zansign==0) {
							this.ly_list[index].zansign=1
						} else{
							this.ly_list[index].zansign=0
						}
						this.$forceUpdate()
					}
				})
			},
			onLoad() {
			      // 异步更新数据
			      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
			    
				var datajson = {
					"ypid":ypid,
					"filmid":this.filmid,
					"wxopenid":wxopenid,
					"pagenow":this.pagenow
				};
				datajson = JSON.stringify(datajson);
				$.ajax({
					type: "get",
					url: "https://mediaapi.hebei.com.cn/api/2025filmreview/api/lylist.php?message=" + datajson,
					datatype: "json",
					success: (data)=> {
						data = JSON.parse(data)
						data = data.data
						for (let i = 0; i < data.lylist.pagenowlist.length; i++) {
							
							this.ly_list.push(data.lylist.pagenowlist[i])
						}
						
						this.pagenow++
						this.loading = false;
									
						// 数据全部加载完成
						if (this.pagenow > data.lylist.pagecount) {
						  this.finished = true;
						}
					}
				})
				
			},
			get_ly_list(){
				
				var datajson = {
					"ypid":ypid,
					"filmid":this.filmid,
					"wxopenid":wxopenid,
					"pagenow":this.pagenow
				};
				datajson = JSON.stringify(datajson);
				$.ajax({
					type: "get",
					url: "https://mediaapi.hebei.com.cn/api/2025filmreview/api/lylist.php?message=" + datajson,
					datatype: "json",
					success: (data)=> {
						
						data = JSON.parse(data)
						data = data.data
						for (let i = 0; i < data.lylist.pagenowlist.length; i++) {
							
							this.ly_list.push(data.lylist.pagenowlist[i])
						}
						this.pagenow++
						this.loading = false;
									
						// 数据全部加载完成
						if (this.pagenow > data.lylist.pagecount) {
						  this.finished = true;
						}
					}
				})
			},
			show_cyzn(){
				this.cyzn_flag = true
			},
			show_jljz(){
				this.jljz_flag = true
			},
			goPhb(){
				this.$router.push({
					name: 'phb',
					query: {
						ypid: ypid
					}
				}, () => {}, () => {})
			},
		},
		mounted() {
			var datajson = {
				"ypid":ypid
			};
			datajson = JSON.stringify(datajson);
			$.ajax({
				type: "get",
				url: "https://mediaapi.hebei.com.cn/api/2025filmreview/api/yplist.php?message=" + datajson,
				datatype: "json",
				// beforeSend: ()=> {
				// 	this.jiazai_flag=true
				// },
				// complete: ()=> {
				// 	this.jiazai_flag=false
				// },
				//成功返回之后调用的函数
				success: (data)=> {
					console.log("data：",data)
					data = JSON.parse(data)
					data = data.data
					this.data = data
					this.flimlist = data.flimlist
					this.filmid = this.data.flimlist[0].film_id
					// this.get_ly_list(this.filmid)
					// this.playerOptions= {
					// 	// 视频源
					// 	sources: [{
					// 	  src: data.hshslist.slowlivelink, // 视频 URL
					// 	  type: 'video/mp4' // 视频类型
					// 	}],
					// 	// 是否自动播放
					// 	autoplay: false,
					// 	// 是否显示控件
					// 	controls: true,
					// 	// 视频宽度
					// 	width: '100%',
					// 	// 视频高度
					// 	height: 'auto',
					// 	// 封面图
					// 	poster: data.hshslist.slowliveimg,
					// 	// 其他配置...
					// 	// playbackRates: [0.5, 1.0, 1.5, 2.0], // 播放速度选择
					// 	fluid: true, // 自适应容器宽度
					// 	muted: false, // 是否静音
					// 	loop: false // 是否循环播放
					// }
				}
			})
			
			
			
			$.ajax({
				type: "get",
				url: "https://mediaapi.hebei.com.cn/api/2025filmreview/api/fwl.php",
				datatype: "json"
			})
		}
	}
</script>

<style scoped="scoped">
	 .centerDiv{
		 background-image: url(../assets/zy/bg.png);
		 background-size: 100% 100%;
		 position: relative;
		 margin-top: -1px;
	 }
	 .bot2{
		 background-image: url(../assets/zy/bot2.png);
		 background-size: 100% 100%;
	 }
</style>